import React, { useState } from "react";
import "../styles/leaderBoard.css";
import TopUser from "./topUser";
import { Avatar } from "@mui/material";

interface User {
  id: number;
  name: string;
  avatarUrl?: string;
  score?: number;
  department?: string;
}

interface LeaderboardProps {
  users: User[];
  handler?: (days: number) => void;
}

const Leaderboard: React.FC<LeaderboardProps> = ({ users, handler }) => {
  const [selectedPeriod, setSelectedPeriod] = useState<number>(14);

  const handleSelection = (days: number) => {
    setSelectedPeriod(days);
    handler?.(days);
  };

  const topUsers = users.slice(0, 3);
  const restUsers = users.slice(3);
  const centerUser = topUsers[0];
  const rightUser = topUsers[1];
  const leftUser = topUsers[2];

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-top">
        <div className="toggle-btns">
          <button
            className={`toggle-btn ${selectedPeriod === 14 ? "active" : ""}`}
            onClick={() => handleSelection(14)}
          >
            دوهفته اخیر
          </button>
          <button
            className={`toggle-btn ${selectedPeriod === 30 ? "active" : ""}`}
            onClick={() => handleSelection(30)}
          >
            یک ماه اخیر
          </button>
        </div>

        <div className="podium">
          {leftUser && <TopUser user={leftUser} position={3} />}
          {centerUser && <TopUser user={centerUser} position={1} />}
          {rightUser && <TopUser user={rightUser} position={2} />}
        </div>
      </div>

      <div className="leaderboard-rest md:max-h-[250px] max-h-[350px] overflow-y-auto">
        {restUsers.map((user, index) => (
          <div key={user.id} className="leaderboard-user">
            <div className="leaderboard-user-info">
              <div className="rank">{index + 4}</div>
              <div className="avatar">
                {user.avatarUrl ? (
                  <Avatar src={user.avatarUrl} alt={user.name} />
                ) : (
                  <Avatar className="placeholder-avatar" />
                )}
              </div>
              <div>
                <div className="name user-name">{user.name}</div>
                <div className="name user-department">
                  {user.department && `(${user.department})`}
                </div>
              </div>
            </div>
            {user.score !== undefined && (
              <div className="score"> % {user.score}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leaderboard;
